import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { Trans } from 'react-i18next';
import { Button } from 'next-common-lib';
import i18n from 'i18n';
import { TERMS_TYPE } from 'constants/IncorporationConstants';
import * as invitationActions from 'redux/ducks/Employee/InvitationDucks';
import UrlLinkError from './UrlLinkError';
import BrityHeader from './Register/FormAtoms/BrityHeader';
import BrityFooter from './Register/FormAtoms/BrityFooter';

export const UrlLinkInvitation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { linkFail, employeeVo, svcType } = useSelector(state => state.invitation);
  const { link } = useParams();

  useEffect(() => {
    dispatch(invitationActions.getInviteLink(link));
  }, [link]);

  return (
    <>
      {linkFail ? (
        <UrlLinkError />
      ) : (
        <>
          <BrityHeader />
          <div className="brity-container registered-area link">
            <div className="brity-contents">
              <div className="brity-content-area">
                <div className="registered-area">
                  <div className="registered-text-area">
                    <div className="ic_signup" />
                    <p className="title">{i18n.t('MB_T_WORKS_INVITE')}</p>
                    <p className="text link comp">
                      <Trans i18nKey={i18n.t('MB_T_WORKS_INVITE_GUIDE', { compNm: employeeVo.compNm })} />
                    </p>
                    <div className="etc-text">
                      {i18n.t('MB_T_AVAILABLE_SERVICE')}{' '}
                      {svcType.includes(TERMS_TYPE.MESSENGER) && `${i18n.t('MB_T_Messenger')}`}
                      {svcType.includes(TERMS_TYPE.MEETING) && ` / ${i18n.t('MB_T_MEETING')}`}
                      {svcType.includes(TERMS_TYPE.DRIVE) && ` / ${i18n.t('MB_T_Drive')}`}
                    </div>
                  </div>
                  <div className="registered-button-area">
                    <Button
                      componentType="solid"
                      className="primary "
                      label={i18n.t('MB_T_SIGNUP_BRITY')}
                      onClick={() => {
                        dispatch(invitationActions.getInviteLink(link));
                        dispatch(invitationActions.setInviteLink(link));
                        navigate.replace('/userapp/register/invitation');
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <BrityFooter />
        </>
      )}
    </>
  );
};
UrlLinkInvitation.propTypes = {};
UrlLinkInvitation.defaultProps = {};
export default UrlLinkInvitation;
